import { render, staticRenderFns } from "./LegalMentions.vue?vue&type=template&id=0e8c96eb&scoped=true&"
import script from "./LegalMentions.vue?vue&type=script&lang=js&"
export * from "./LegalMentions.vue?vue&type=script&lang=js&"
import style0 from "./LegalMentions.vue?vue&type=style&index=0&id=0e8c96eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8c96eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VContainer,VFlex,VForm,VLayout,VToolbar,VToolbarTitle})
